// extracted by mini-css-extract-plugin
export var adv = "style-module--adv--da0a9";
export var authors = "style-module--authors--f62de";
export var carousel = "style-module--carousel--f5bdc";
export var cot = "style-module--cot--acf23";
export var inner = "style-module--inner--86db2";
export var lic = "style-module--lic--05a9e";
export var wrap = "style-module--wrap--8ed7d";